import { styled } from '@methanesat/ui-components'
import { ONE_HUNDRED_VH_STYLING } from '../../consts';

const PageContainer = styled('div')({
    flexDirection: 'column',
    display: 'flex',
    height: ONE_HUNDRED_VH_STYLING
});

export default PageContainer;